import { render } from "./draggableTree.vue?vue&type=template&id=73e598cd&scoped=true&ts=true"
import script from "./draggableTree.vue?vue&type=script&lang=ts"
export * from "./draggableTree.vue?vue&type=script&lang=ts"

import "./draggableTree.vue?vue&type=style&index=0&id=73e598cd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e598cd"]])

export default __exports__